exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".search-result{  \n  width:230;\n  padding: 5px;\n  background-color: white;\n  cursor: pointer;\n\n  top: 49px;\n    border-width: 1px;\n    border-style: solid;\n    border-bottom: none;\n    border-radius: 5px;\n    background: #f7f7f7;\n    background: linear-gradient(to bottom, #f7f7f7, #f4f4f4);\n    box-shadow: 0 1px 0 0 rgba(0,0,0,0.2), inset 0px 1px 0 #fff;\n    text-shadow: 0 1px 0 #fff;\n\n}\n#search-box{\n  width: 230px;\n  height: 20px;\n  top: 49px;\n    border-width: 1px;\n    border-style: solid;\n    border-color: rgba(0,0,0,0.1);\n    border-bottom: none;\n    border-radius: 5px;\n    background: #f7f7f7;\n    background: linear-gradient(to bottom, #f7f7f7, #f4f4f4);\n    box-shadow: 0 1px 0 0 rgba(0,0,0,0.2), inset 0px 1px 0 #fff;\n    text-shadow: 0 1px 0 #fff;\n}\n\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/users/search/user-search.component.css
// module id = 122
// module chunks = 1